import { Button, Callout, Intent } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { StyledDialog } from "@/components/pieces/StyledDialog";

export interface RoleplaySessionResetConfirmProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RoleplaySessionResetConfirm({
  open,
  onClose,
  onConfirm,
}: RoleplaySessionResetConfirmProps) {
  return (
    <StyledDialog
      isOpen={open}
      centered={true}
      lazy={true}
      title="Reset Scenarios Session?"
      width="480px"
      onClose={() => {
        onClose();
      }}
    >
      <Box p={24}>
        <Box mb={3}>
          <Callout icon={null} intent={Intent.DANGER}>
            Are you sure you want to reset this scenario? Your current session
            data will be lost and cannot be recovered.
          </Callout>
        </Box>
        <Box>
          <Button intent={Intent.DANGER} large={true} onClick={onConfirm}>
            Reset
          </Button>
          <Button
            large={true}
            onClick={() => {
              onClose();
            }}
            style={{ marginLeft: 12 }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </StyledDialog>
  );
}
